import { fromJS, merge } from 'immutable';
import { FluxStandardAction } from '__utils/type';
import * as Actions from 'constants/actions'


export interface KycComplianceState {
    kycDetails?: any;
    fetchKycDetailsError: any;   
    requestId?: any;   
}
const rawState: KycComplianceState = {
    fetchKycDetailsError: "",  
};

const intialState = fromJS(rawState);

export default function panDetailsReducer(
    state = intialState,
    action: FluxStandardAction
) {
    switch (action.type) {
        case Actions.FETCH_CHECK_KYC_STATUS_SUCCESS:
            return merge(state, fromJS({ kycDetails: action.payload.data}));
        case Actions.FETCH_CHECK_KYC_STATUS_ERROR:
            return merge(state, fromJS({ fetchKycDetailsError: action.payload.data?.message }));
        case Actions.SET_REQUEST_ID:
            return merge(state, fromJS({ requestId: action.payload.data }));
        default:
            return state;
    }
}
